import {
  NG_VALIDATORS,
  UntypedFormControl,
  ValidatorFn,
  Validator
} from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
  selector: '[basicCharsValidator][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useClass: BasicCharactersValidator,
      multi: true
    }
  ]
})
export class BasicCharactersValidator implements Validator {
  validator: ValidatorFn;
  constructor() {
    this.validator = this.basicCharsValidator();
  }
  validate(c: UntypedFormControl) {
    return this.validator(c);
  }

  basicCharsValidator(): ValidatorFn {
    return (c: UntypedFormControl) => {
      const isValid = /^[\w\s_'`.-]*$/.test(c.value);
      if (isValid) {
        return null;
      } else {
        return {
          basicCharsValidator: {
            valid: false
          }
        };
      }
    };
  }
}

